import {HttpRequest} from "../utils/httpRequest";

let Depart = {
    /**
     * 获取数据列表
     * @param datas
     * @returns {*}
     */
    getDepartList(datas) {
        return HttpRequest.getRequest({
            url: '/edu/department/list',
            method: 'get',
            data: datas
        });
    },
    /**
     * 获取所有数据
     * @returns {*}
     */
    getAllDepart() {
        return HttpRequest.getRequest({
            url: '/edu/department/all',
            method: 'get'
        });
    },
    /**
     * 根据id查看信息
     * @param id
     * @returns {*}
     */
    getDepartInfo(id) {
        return HttpRequest.getRequest({
            url: '/edu/department/info/' + id,
            method: 'get',
        });
    },
    /**
     * 新增或编辑数据
     * @param type
     * @param datas
     * @returns {*}
     */
    addOrUpdateDepart(type, datas) {
        return HttpRequest.getRequest({
            url: '/edu/department/' + type,
            method: 'post',
            data: datas
        });
    },
    /**
     *删除数据
     * @param datas
     */
    deleteDepart(datas) {
        return HttpRequest.getRequest({
            url: '/edu/department/delete',
            method: 'get',
            data: datas
        });
    }

};
export {Depart}
